import { Box, Button, CircularProgress, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import SelectLocaisCobranca from "../../../../../../../components/SelectsSimpleApiQuery/SelectLocaisCobranca";
import SelectSituacaoFinanceira from "../../../../../../../components/SelectsSimpleApiQuery/SelectSituacaoFinanceira";
import SelectFuncoes from "../../../../../../../components/SelectsSimpleApiQuery/SelectFuncao";
import SelectPlanoContas from "../../../../../../../components/SelectsSimpleApiQuery/SelectPlanoContas";
import SelectLoja from "../../../../../../../components/SelectsSimpleApiQuery/SelectLoja";
import SelectDepartamentoFinanceiro from "../../../../../../../components/SelectsSimpleApiQuery/SelectDepartamentoFinanceiro";

export default function Step03() {
  //useFormContext
  const { setError, getValues, watch, handleSubmit, control } = useFormContext()
  const handleBack = getValues('funcoesAux.onBack')
  const onSubmit = getValues('funcoesAux.onSubmit')
  const valores: TInternFilters = watch('outrasInfos')
  const isLoading = watch('isLoadingIncluirTitulo')
  //

  //Funções manipuladoras
  const handleValidarCampos = (data: any) => {
    const { outrasInfos } = data
    if (outrasInfos.vincular_outro_publico === 'Sim') {
      const possuiPropriedadesPreenchidas = Object.keys(outrasInfos.publico_vinculado).some(
        (key) => outrasInfos.publico_vinculado[key] && outrasInfos.publico_vinculado[key].trim() !== ''
      );
      if (!possuiPropriedadesPreenchidas) {
        setError('outrasInfos.publico_vinculado', { type: 'manual', message: 'Preencha os dados do publico vinculado' })
        return false
      }
    }
    return true;
  }

  const handleSubmitForm = (data: any) => {
    if (handleValidarCampos(data)) {
      onSubmit(data)
    }
  }
  //

  const valoresSelect = [{ value: 'Não', label: 'Não' }, { value: 'Sim', label: 'Sim' }]
  return (
    <Grid container spacing={2}>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.loja"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectLoja
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
              extraParams={{ somente_vinculadas: true }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.departamento"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectDepartamentoFinanceiro
              {...field}
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.funcoes"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectFuncoes
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.local_cobranca"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectLocaisCobranca
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.situacao"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectSituacaoFinanceira
              required
              error={invalid}
              value={field.value}
              onChange={(valor) => field.onChange(valor)}
            />
          )}
        />

      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.conta_contabil"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectPlanoContas
              inputLabel="Conta contábil"
              value={field.value}
              required
              error={invalid}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ sistema_xy: "D-REC" }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.contra_partida"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field, fieldState: { invalid } }) => (
            <SelectPlanoContas
              inputLabel="Contra partida"
              value={field.value}
              required
              error={invalid}
              onChangeValue={(valor) => field.onChange(valor)}
              extraParams={{ tipo: "Analítica" }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.objeto"
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              label="Objeto"
              fullWidth
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value.trimStart());
              }}
              slotProps={{ htmlInput: { maxLength: 20 } }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="outrasInfos.historico"
          control={control}
          render={({ field, fieldState: { error, invalid } }) => (
            <TextField
              label="Histórico"
              fullWidth
              value={field.value}
              onChange={(e) => {
                field.onChange(e.target.value.trimStart());
              }}
              slotProps={{ htmlInput: { maxLength: 30 } }}
            />
          )}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Controller
          name="outrasInfos.vincular_outro_publico"
          control={control}
          rules={{ required: 'Campo obrigatório' }}
          render={({ field }) => (
            <FormControl {...field} fullWidth>
              <FormLabel id={`Vincular-radio`}>Vincular título a outro público?</FormLabel>
              <RadioGroup
                row
                aria-labelledby="radioSimOuNao"
                value={field.value}
                onChange={({ target }) => field.onChange(target.value)
                }
              >
                {
                  valoresSelect.map((opcao, index) => (
                    <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                  ))
                }
              </RadioGroup>
            </FormControl>
          )}
        />
      </Grid>
      {
        valores.vincular_outro_publico === 'Sim' &&
        <Grid size={{ xs: 6 }}>
          <Controller
            name="outrasInfos.publico_vinculado"
            control={control}
            render={({ field, fieldState: { invalid, error } }) => {
              return (
                <SelectPublico
                  {...field}
                  error={invalid}
                  required
                  errorMessage={error?.message}
                  value={field.value}
                  onChange={(valor) => field.onChange(valor)}
                />
              )
            }}
          />
        </Grid>
      }
      <Grid size={{ xs: 12 }}>
        <Box display={'flex'} gap={2}>
          <Button
            variant="outlined"
            onClick={handleBack}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit(handleSubmitForm)}
            disabled={isLoading}
          >
            {
              isLoading &&
              <CircularProgress size={20} sx={{ marginRight: 1 }} />
            }
            Cadastrar
          </Button>
        </Box>
      </Grid>
    </Grid>
  )
}

type TInternFilters = {
  [key: string]: any;
}
